<template>
    <BaseSelect v-bind="$attrs" autocomplete="off">
        <template #no-options>{{ t('no-options') }} </template>

        <template #open-indicator="{ attributes }">
            <BottomArrowSvg v-bind="attributes">^</BottomArrowSvg>
        </template>

        <template v-for="(_, slot) of $slots" v-slot:[slot]="scope">
            <slot :name="slot" v-bind="scope"></slot>
        </template>
    </BaseSelect>
</template>

<script setup lang="ts">
// Svg
import BottomArrowSvg from '@/assets/bottom-arrow.svg';

// Components
import BaseSelect from 'vue-select';

// Other
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>
